export default "__VITE_ASSET__CR$a2$Cb__"